export const BASE_TYPE_MAP_EDITOR = {
  1: 'RadioSelect',
  2: 'MultiSelect',
  3: 'TypeText',
  4: 'DropSelect',
  5: 'Cascade'
}

export const BASE_TYPE_CHECK_DATA_FUN = {
  1: 'checkRadioData',
  2: 'checkMultiData',
  3: 'checkTextData',
  4: 'checkDropData',
  5: 'checkCascadeData'
}
